import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_CoreOrderForServices = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_CoreOrderForServices' className='file-pdf-document'>

            <div className='file-template'>


                <h4>Non-Intensive Outpatient Services</h4>
                <p className='w-750'>
                    <input type="checkbox" name="cbServicePlanDevelopment" id="cbServicePlanDevelopment" className='add-only' value="BehavioralHealthAssessmentServicePlanDevelopment" /> Behavioral Health Assessment/Service Plan Development: H0031 & H0032
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbSupportServices" id="cbSupportServices" className='add-only' value="AddictiveDiseaseSupportServices" /> Addictive Disease Support Services (ADSS): H2015 HF
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Specific to adults with addictive disease issues, Addictive Diseases Support Services (ADSS) consist of substance
                            abuse recovery services and supports. The service activities include:
                        </li>
                        <li>Assistance to the person and other identified recovery
                        </li>
                        <li>Support to increase natural supports
                        </li>
                        <li>Skills training & Coping
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbFamilyIntervention" id="cbFamilyIntervention" className='add-only' value="IntensiveFamilyInterventionIFIAdmissionCriteria" />
                    Intensive Family Intervention (IFI) Admission Criteria: H0036
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a diagnosis and duration of symptoms that classify
                            the illness as SED and/or is diagnosed Substance related disorder; and one or more of the following:
                        </li>
                        <li>Individual has received services through other service modes and needs additional or different supports or
                            structure. Treatment at a lower intensity has been attempted or given serious consideration; or
                        </li>
                        <li>Individual and/or family has insufficient or severely limited resources or skills necessary to cope with an
                            Immediate behavioral health crisis; or
                        </li>
                        <li>Individual and/or family behavioral health issues are unmanageable in traditional outpatient treatment and require
                            Intensive, coordinated clinical and supportive intervention; or
                        </li>
                        <li>Because of behavioral health issues the individual is at risk of out of home placement or is currently in out of
                            home placement and reunification is imminent; or
                        </li>
                        <li>Because of behavioral health issues, the individual is at immediate risk of legal system intervention or is currently
                            with DJJ.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbCaseManagement" id="cbCaseManagement" className='add-only' value="CaseManagementCM" />
                    Case Management (CM): T1016
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual must meet target population criteria: and one or more of
                            the following:
                        </li>
                        <li>Individual may need assistance with developing, maintaining, or
                            Enhancing social support or other community coping skills; or
                        </li>
                        <li>Individual may need assistance with daily living skills including coordination to gain access to necessary rehab
                            and medical services.
                        </li>
                        <li>Linkage to community resources, natural supports, monitoring of IRP
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                </p>
                <ol type="a">
                    <li>navigate and self manage necessary services;
                    </li>
                    <li>maintain personal hygiene;
                    </li>
                    <li>meet nutritional needs;
                    </li>
                    <li>care for personal business affairs;
                    </li>
                    <li>obtain or maintain medical, legal, and housing services;
                    </li>
                    <li>recognize and avoid common dangers or hazards to self and possessions;
                    </li>
                    <li>perform daily living tasks;
                    </li>
                    <li>obtain or maintain employment at a self-sustaining level or consistently perform homemaker roles (e.g., household meal preparation, washing clothes,
                        budgeting, or childcare tasks and responsibilities);
                    </li>
                    <li>maintain a safe living situation
                    </li>
                </ol>
                <p className='w-750'>
                    <input type="checkbox" name="cbCommunitySupport" id="cbCommunitySupport" className='add-only' value="CommunitySupportIndividualCSIAdmissionCriteria" />
                    Community Support Individual (CSI) Admission Criteria : H2015
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual must meet target population criteria: and one or more of the following:
                        </li>
                        <li>Individual may need assistance with developing, maintaining, or
                            Enhancing social support or other community coping skills; or
                        </li>
                        <li>Individual may need assistance with daily living skills including coordination to gain access to necessary rehab
                            and medical services.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbCrisesIntervention" id="cbCrisesIntervention" className='add-only' value="CrisisInterventionAdmissionCriteria" />
                    Crisis Intervention Admission Criteria: H2011, 90839, 90840
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual must meet target population criteria: and one or more of
                            the following:
                        </li>
                        <li>Crisis Intervention is designed to prevent out of home placement or hospitalization.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbPsychosocialRehabilitation" id="cbPsychosocialRehabilitation" className='add-only' value="PsychosocialRehabilitation" />
                    Psychosocial Rehabilitation-I (PSR-I):H2017 HE
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual must meet target population criteria: and one or more of
                            the following:
                        </li>
                        <li>Individual may need assistance with developing, maintaining, or
                            Enhancing social support or other community coping skills; or
                        </li>
                        <li>Individual may need assistance with daily living skills including coordination to gain access to necessary rehab
                            and medical services.
                        </li>
                        <li>Linkage to community resources, natural supports, monitoring of IRP
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <ol type="a">
                        <li>navigate and self-manage necessary services;
                        </li>
                        <li>maintain personal hygiene;
                        </li>
                        <li>meet nutritional needs;
                        </li>
                        <li>care for personal business affairs;
                        </li>
                        <li>obtain or maintain medical, legal, and housing services;
                        </li>
                        <li>recognize and avoid common dangers or hazards to self and possessions;
                        </li>
                        <li>perform daily living tasks;
                        </li>
                        <li>obtain or maintain employment at a self-sustaining level or consistently perform homemaker roles (e.g., household meal preparation, washing clothes,
                            budgeting, or childcare tasks and responsibilities); i.e.. maintain a safe living situation
                        </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbAdmissionCriteria" id="cbAdmissionCriteria" className='add-only' value="IndividualCounselingAdmissionCriteria" />
                    Individual Counseling Admission Criteria: 90832, 90832, 90834, 90834, 90837
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a primary emotional disturbance/substance disorder
                            the illness as SED and/or is diagnosed Substance related disorder dx that is
                            at least destabilizing (markedly interferes with the ability to carry out
                            activities of daily living or places others in danger) or distressing (causing
                            mental anguish or suffering); and
                        </li>
                        <li>Individual's level of functioning does not preclude the provision of services in an outpatient setting; and
                        </li>
                        <li>Individual's resiliency goal that is to be addressed by these services must be conducive to response by an
                            Individual therapeutic setting
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbAdmissionCriteria1" id="cbAdmissionCriteria1" className='add-only' value="FamilyTrainingCounselingAdmissionCriteria" />
                    Family Training/Counseling Admission Criteria : 90846, 90847, H0004, H2014
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a primary emotional disturbance/substance related disorder
                            that is at least destabilizing (markedly interferes with the ability to carry out activities of daily living) or distressing
                            (causes mental anguish or suffering) and;
                        </li>
                        <li>Individual's level of functioning does not preclude the provision of services in an outpatient setting; and
                        </li>
                        <li>Individual's assessment indicates needs that may be successful with identified family members and individuals dx
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbAdmissionCriteria2" id="cbAdmissionCriteria2" className='add-only' value="GroupTrainingCounselingAdmissionCriteria" />
                    Group Training/Counseling Admission Criteria(90853, H0004):
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a primary illness/substance related disorder
                            is at least destabilizing (markedly interferes with the ability to carry out
                            activities of daily living or places others in danger) or distressing (causing
                            mental anguish or suffering); and
                        </li>
                        <li>Individual's level of functioning does not preclude the provision of services in an outpatient setting; and
                        </li>
                        <li>Individual's resiliency goal that is to be addressed by these services must be conducive to response by an
                            group setting
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ordered By:</span>
                            <input type="text" name="txtOrderedBy" id="txtOrderedBy" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Ordered:</span>
                            <input type="date" name="txtDateOrdered" id="txtDateOrdered" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-275'>&nbsp;</td>
                        <td className='signature w-275'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-275'>Signature</td>
                        <td className='small w-275'>Credentials</td>
                        <td className='small w-200'>Date</td>
                    </tr>
                </table>




            </div>
        </form>

    )
} 
